﻿import { FindElById } from './script.js'; 

var feedURL = '/feeds/ajax_postcode.aspx';

function validatePostcode(Postcode) {
    if (stringContainsTags(Postcode)) {
        alert('This is not a valid UK postcode.');
        return false;
    }
    return true;
}
function txtFindPostcode_Keypress(ctl, evt) {
    if (enterKey(ctl, evt)) {
        findAddress_Click();
        return false;
    }
    return true;
}
function txtFindPostcode2_Keypress(ctl, evt) {
    if (enterKey(ctl, evt)) {
        findAddress2_Click();
        return false;
    }
    return true;
}

function resField_Keypress(ctl, evt) {
    if (enterKey(ctl, evt)) {
        $('.continue').click();
        return false;
    }
    return true;
}

function enterKey(ctl, evt) {
    var keyCode = evt.keyCode ? evt.keyCode : evt.which ? evt.which : evt.charCode;
    return (keyCode == 13);
}

var postCodeFinderControl;
function findAddress_Click(pcfControl) {
    postCodeFinderControl = pcfControl;
    FindElById('noAddresses').innerHTML = '';
    FindElById('showAddresses').style.display = 'none';
    var postCode = FindElById('txtFindPostcode').value;
    document.getElementsByClassName('txtPostCode')[0].value = postCode;

    if (validatePostcode(postCode)) {
        if (FindElById('txtFindPostcode2')) {
            FindElById('fsPostcode').style.display = 'block';
            selectAll('txtFindPostcode2');
            FindElById('txtFindPostcode2').value = postCode;
            findAddress(postCode);
        }
    }
}

function findAddress2_Click() {
    //$('matchingAddresses').options.length = 0;
    jQuery("#matchingAddresses").empty();
    FindElById('noAddresses').innerHTML = '';
    FindElById('showAddresses').style.display = 'none';
    FindElById('noAddresses').style.display = 'none';
    var postCode = FindElById('txtFindPostcode2').value;
    FindElById('txtFindPostcode').value = postCode;
    document.getElementsByClassName('txtPostCode')[0].value = postCode;
    if (validatePostcode(postCode)) {
        findAddress(postCode);
    }
}

// make the function accessible in the global scope
window.findAddress_Click = findAddress_Click;
window.findAddress2_Click = findAddress2_Click;
function findAddress(postCode) {
    if (postCode.length == 0) {
        FindElById('noAddresses').style.display = 'block';
        FindElById('noAddresses').innerHTML = 'Enter a UK Postcode to find your address.';
        FindElById('waitAddresses').style.display = 'none';
        selectAll('txtFindPostcode2');
        return;
    }
    if (pendingEvent != null) {
        clearTimeout(pendingEvent);
    }
    FindElById('waitAddresses').style.display = 'block';
    FindElById('showAddresses').style.display = 'none';
    var url = feedURL + '?postCode=' + postCode;
    var method = "GET";
    $.ajax({
        url: url,
        dataType: "xml",
        success: function (xml) {
            findAddress_OnResponse(xml);
        }
    });
}

function findAddress_OnResponse(responseXML) {
    if (pendingEvent != null) {
        clearTimeout(pendingEvent);
    }
    FindElById('waitAddresses').style.display = 'none';
    FindElById('waitAddresses2').style.display = 'none';
    var matchingAddresses = FindElById('matchingAddresses');
    var noAddresses = FindElById('noAddresses');
    var xmlDoc = responseXML;
    var results = xmlDoc.getElementsByTagName('Item');
    var i;
    jQuery("#matchingAddresses").empty();
    //matchingAddresses.options.length = 0;
    noAddresses.innerHTML = '';
    if (results.length == 0) {
        noAddresses.style.display = 'block';
        noAddresses.innerHTML = 'Sorry, no addresses were found for this postcode.';
        if (postcodeModal) {
            selectAll('txtFindPostcode2');
        }
    } else if (results.length == 1) {
        if (results[0].getAttribute('error_number')) {
            FindElById('noAddresses').style.display = 'block';
            noAddresses.innerHTML = 'Sorry, no addresses were found for this postcode.';
            if (postcodeModal) {
                selectAll('txtFindPostcode2');
            }
        } else {
            FindElById('matchingAddresses').value = results[0].getAttribute('id');
            matchingAddresses_Click();
        }
    } else if (results.length > 1) {
        FindElById('showAddresses').style.display = 'block';
        FindElById('noAddresses').style.display = 'none';
        for (i = 0; i < results.length; i++) {
            if (results[i].getAttribute('description')) {
                jQuery('#matchingAddresses').each(function (index) {
                    jQuery('#matchingAddresses').append('<li onClick="matchingAddresses_Click(' + results[i].getAttribute("id") + ')" value=' + results[i].getAttribute('id') + '>' + results[i].getAttribute('description') + '</li>');
                });
                //                matchingAddresses.options[matchingAddresses.options.length] = new Option(results[i].getAttribute('description'), results[i].getAttribute('id'));
            }
        }
    }
}
function matchingAddresses_Click(addressID) {
    FindElById('waitAddresses').style.display = 'block';
    FindElById('showAddresses').style.display = 'none';
    var url = feedURL + '?addressID=' + addressID;
    $.ajax({
        url: url,
        dataType: "xml",
        success: function (xml) {
            matchingAddresses_OnResponse(xml);
        }
    });
}
function matchingAddresses_OnResponse(responseXML) {
    //var matchingAddresses=$('matchingAddresses');
    var xmlDoc = responseXML;
    var result = xmlDoc.getElementsByTagName('Item')[0];
    if (result.getAttribute('error_number')) {
        FindElById('waitAddresses').style.display = 'none';
        FindElById('noAddresses').style.display = 'block';
        FindElById('noAddresses').innerHTML = 'Sorry, no addresses were found for this postcode.';
        selectAll('txtFindPostcode2');
        return;
    }
    document.getElementsByClassName('txtPostCode')[0].value = '';
    document.getElementsByClassName('txtAdd1')[0].value = '';

    if (result.getAttribute('organisation_name')) {
        document.getElementsByClassName('txtAdd1')[0].value += result.getAttribute('organisation_name') + ', ';
    }
    document.getElementsByClassName('txtAdd1')[0].value += result.getAttribute('line1');
    
    if (result.getAttribute('line2')) {
        document.getElementsByClassName('txtAdd2')[0].value = result.getAttribute('line2');
    } else {
        document.getElementsByClassName('txtAdd2')[0].value = ''
    }

    if (result.getAttribute('line3')) {
        document.getElementsByClassName('txtAdd3')[0].value = result.getAttribute('line3');
    } else {
        document.getElementsByClassName('txtAdd3')[0].value =  '';
    }
    if (result.getAttribute('line4')) {
        document.getElementsByClassName('txtAdd3')[0].value += ', ' + result.getAttribute('line4');
    }
    
    document.getElementsByClassName('txtTown')[0].value = result.getAttribute('post_town');
    document.getElementsByClassName('txtCounty')[0].value = result.getAttribute('county');
    if (result.getAttribute('postcode')) {
        document.getElementsByClassName('txtPostCode')[0].value = result.getAttribute('postcode');
    }
    document.getElementsByClassName('ddlCountry')[0].value = 'GB';

    $('#close-modal').click();

}

function getNetControlById(controlId) {
    return document.getElementById(controlId);
}

// Returns true if s contains Html tags.
function stringContainsTags(s) {
    if (!s) { s = '' };
    var regExp = new RegExp("<|>|;||/?|[|/^|]|/+|$", "g")
    var newS = s.replace(regExp, "");
    if (newS != s) {
        return true;
    } else {
        return false;
    }
}
var curFocus = '';
var postcodeModal = false;
var pendingEvent;
function selectAll(id) {
    document.getElementById(id).focus();
    if (id != curFocus) {
        document.getElementById(id).select();
    }
    curFocus = id;
}